export default () => localStorage.removeItem('sessionKey')
